import Layout from '@/layout/ezpay-index.vue'

export const agentMerchantRouter = {
  path: '/agentMerchant',
  component: Layout,
  redirect: '/agentMerchant',
  name: 'Agent_Merchant_Manage',
  meta: { title: 'merchants', icon: 'merchant' },
  alwaysShow: true,
  children: [
    {
      path: 'list',
      name: 'Agent_Merchant_List',
      component: () => import('@/views/ezpay/agent-merchant/list.vue'),
      meta: {
        title: 'merchant_list', noCache: false,
        auth: ['ROLE_AUTH_AGENT_ADMIN']
      }
    }

  ]
}

